import { api } from ".";
import { LasMaterialContractBase } from "../types/lasMaterialContractBase";
import { LasMaterialUpdate } from "../types/lasMaterialUpdate";

export default class LasMaterialApi {
  static async login(id: number, email: string) {
    const res = await api.post("/lasMaterialContract/login", {
      id: id,
      email: email,
    });
    return res.data;
  }

  static async getContract(): Promise<LasMaterialContractBase> {
    const res = await api.get("/lasMaterialContract/getContract");
    return res.data;
  }

  static async getUpdatedLasMaterial(id: number): Promise<LasMaterialUpdate> {
    const res = await api.get(
      `/lasMaterialContract/getUpdatedLasMaterial?id=${id}`
    );
    return res.data;
  }

  static async updateLasMaterial(
    price: string,
    leadTimeDays: number,
    lasMaterialId: number
  ): Promise<LasMaterialContractBase> {
    const res = await api.post("/lasMaterialContract/updateLasMaterial", {
      lasMaterialUpdate: {
        price: price,
        leadTimeDays: leadTimeDays,
      },
      lasMaterialId: lasMaterialId,
    });
    return res.data;
  }

  static async updateContract(iva: string): Promise<LasMaterialContractBase> {
    const res = await api.post("/lasMaterialContract/updateContract", {
      lasMaterialContractUpdate: {
        iva: iva,
      },
    });
    return res.data;
  }

  static async partialUpdateContract(
    iva: string
  ): Promise<LasMaterialContractBase> {
    const res = await api.post("/lasMaterialContract/partialUpdateContract", {
      lasMaterialContractUpdate: {
        iva: iva,
      },
    });
    return res.data;
  }

  static async setDiscontinued(id: number, discontinued: boolean) {
    await api.post("/lasMaterialContract/setDescontinued", {
      lasMaterialId: id,
      discontinued: discontinued,
    });
  }

  static async setKeepConditions(keepConditions: boolean) {
    await api.post("/lasMaterialContract/setKeepConditions", {
      keepConditions: keepConditions,
    });
  }

  static async setProblem(issueText: string) {
    await api.post("/lasMaterialContract/problem", {
      issueText: issueText,
    });
  }
}
